const EasingValues = Object.freeze({
    '--easing-ease': 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    '--easing-ease-in': 'cubic-bezier(0.42, 0, 1, 1)',
    '--easing-ease-in-out': 'cubic-bezier(0.42, 0, 0.58, 1)',
    '--easing-ease-out': 'cubic-bezier(0, 0, 0.58, 1)',
    '--easing-linear': 'cubic-bezier(0, 0, 1, 1)',
    '--easing-practical': 'cubic-bezier(0.3, 0.15, 0.5, 1)',
    '--easing-expressive': 'cubic-bezier(0.5, 0.05, 0.3, 1)',
    '--easing-bounce': 'cubic-bezier(0.5, -0.4, 0.55, 1.4)',
});
const Easing = {
    ease: 'var(--easing-ease)',
    easeIn: 'var(--easing-ease-in)',
    easeInOut: 'var(--easing-ease-in-out)',
    easeOut: 'var(--easing-ease-out)',
    linear: 'var(--easing-linear)',
    practical: 'var(--easing-practical)',
    expressive: 'var(--easing-expressive)',
    bounce: 'var(--easing-bounce)',
};

export { Easing, EasingValues };
